import { call, put, select } from "redux-saga/effects";
import { setStatuses } from "services/Status/actions";
import { normalize, schema } from "normalizr";

import { showError } from "../../utils/sagasErrorHandler";

import { getStatusRequest } from "./api";
import { statusesSelector } from "./selectors";


const statusesSchema = new schema.Entity("statuses" , {},{ idAttribute: "code" });
const statusesListSchema = new schema.Array(statusesSchema);

function* getStatusWorker() {
    try {
        const { codes } = yield select(statusesSelector);
        if(!codes.length){
            yield put(setStatuses({ isLoadingStatuses: true }));
            const { statuses } = yield call(getStatusRequest);
            const { result, entities } = normalize(statuses, statusesListSchema);
            yield put(setStatuses({
                isLoadingStatuses: false,
                statuses: entities.statuses,
                codes: result
            }));
        }
    } catch (error) {
        yield put(setStatuses({ isLoadingStatuses: false }));
        showError(error);
    }
}

export function* getStatus() {
    yield call(getStatusWorker);
}
